/**
 * Admin dashboard auth token — kept separate from storefront `token` so an
 * embedded storefront iframe on the same origin cannot clear the admin session.
 */
const TOKEN_KEY = 'quazbit_admin_token';
const LEGACY_TOKEN_KEY = 'token';

export function getAuthToken() {
    return (
        localStorage.getItem(TOKEN_KEY) ||
        sessionStorage.getItem(TOKEN_KEY) ||
        localStorage.getItem(LEGACY_TOKEN_KEY) ||
        sessionStorage.getItem(LEGACY_TOKEN_KEY) ||
        null
    );
}

export function setAuthToken(token, { rememberMe = true } = {}) {
    const primary = rememberMe ? localStorage : sessionStorage;
    const secondary = rememberMe ? sessionStorage : localStorage;

    primary.setItem(TOKEN_KEY, token);
    secondary.removeItem(TOKEN_KEY);

    // Drop legacy key so storefront preview iframes cannot read or overwrite it.
    localStorage.removeItem(LEGACY_TOKEN_KEY);
    sessionStorage.removeItem(LEGACY_TOKEN_KEY);
}

export function clearAuthToken() {
    localStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(LEGACY_TOKEN_KEY);
    sessionStorage.removeItem(LEGACY_TOKEN_KEY);
}

export function usesPersistentAuthStorage() {
    return Boolean(
        localStorage.getItem(TOKEN_KEY) || localStorage.getItem(LEGACY_TOKEN_KEY),
    );
}
